import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention,react/no-danger */
import DOMPurify from 'dompurify';
import Styles from './styles';
const Notice = ({ onClose, content, children, containerStyles, }) => {
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    return (_jsx(Styles.Backdrop, { onClick: onClose, children: _jsxs(Styles.Inner, { className: "primary-modal-content", style: containerStyles, onClick: stopProp, children: [_jsx(Styles.Close, { className: "close", type: "button", onClick: onClose, title: "Close Modal", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }), content && (_jsx("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(content) } })), children] }) }));
};
Notice.defaultProps = {
    content: undefined,
    containerStyles: undefined,
};
export default Notice;
